import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  height: 60px;\n  width: 60px;\n  text-align: center;\n  padding: 0;\n  margin: 0 auto 10px auto;\n  background-color: ", ";\n  border-radius: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  &:hover {\n    cursor: pointer;\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  font-size: 12px;\n  font-weight: 400;\n  height: 16px;\n  text-align: center;\n  margin: 0;\n  color: ", ";\n  ", "\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 22px;\n  text-align: center;\n  margin-bottom: 6px;\n  margin-top: 0;\n  color: ", ";\n  color: ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 30px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import { AcornsIcon } from '@acorns/icons';
import styled from '../utils/styling/styled-components';
import { RELOAD_BUTTON, ERROR_STATE } from '../utils/testing/TestIDs';
var ErrorContainer = styled.div(_templateObject());
var ErrorMessage = styled.p(_templateObject2(), function (props) {
  return props.theme.colors.white;
}, function (props) {
  return props.darkMode ? props.theme.colors.white : props.theme.colors.slate;
});
var ErrorSubMessage = styled.p(_templateObject3(), function (props) {
  return props.darkMode ? props.theme.colors.white : props.theme.colors.slate;
}, function (props) {
  return !props.darkMode && 'opacity: 0.6;';
}); // @ts-ignore
//using hex values for opacity for color

var IconContainer = styled.div.attrs({
  'data-testid': RELOAD_BUTTON
})(_templateObject4(), function (props) {
  return props.darkMode ? 'rgba(25, 25, 25, 0.06)' : props.theme.colors.ivory;
});
export var ErrorState = function ErrorState(_ref) {
  var onClickReload = _ref.onClickReload,
      _ref$darkMode = _ref.darkMode,
      darkMode = _ref$darkMode === void 0 ? true : _ref$darkMode,
      _ref$errorMessage = _ref.errorMessage,
      errorMessage = _ref$errorMessage === void 0 ? 'Unable to load data' : _ref$errorMessage,
      _ref$errorSubMessage = _ref.errorSubMessage,
      errorSubMessage = _ref$errorSubMessage === void 0 ? 'Tap to retry' : _ref$errorSubMessage;
  return /*#__PURE__*/React.createElement(ErrorContainer, {
    onClick: onClickReload,
    "data-testid": ERROR_STATE
  }, /*#__PURE__*/React.createElement(IconContainer, {
    darkMode: darkMode
  }, /*#__PURE__*/React.createElement(AcornsIcon, {
    icon: darkMode ? AcornsIcon.Icon.ReloadWhite : AcornsIcon.Icon.Reload,
    width: 24,
    height: 24
  })), /*#__PURE__*/React.createElement(ErrorMessage, {
    darkMode: darkMode
  }, errorMessage), /*#__PURE__*/React.createElement(ErrorSubMessage, {
    darkMode: darkMode
  }, errorSubMessage));
};